import { ReactNode } from "react";
import { View } from "./View";

export interface IThreeLeveledSectionProps {
  titleLogo: ReactNode;
  rightFirstItem: ReactNode;
  rightSecondItem: ReactNode;
  rightThirdItem: ReactNode;
  checked: boolean;
  isLoading: boolean;
  onToggle: () => void;
  hasBorder: boolean;
  className?: string;
}

export const ThreeLeveledSection = (props: IThreeLeveledSectionProps) => {
  return <View {...props} />;
};
